import { WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../../constants';
import {
  ReflectionTopicsDrawerControlsWrapper as BaseReflectionTopicsDrawerControlButton,
  ReflectionTopicsDrawerControlMenuItemWrapper as BaseReflectionTopicsDrawerControlMenuItem,
} from '../../reflections/ReflectionTopicsDrawerControlsWrapper';

export function VisitorWaitingReflectionTopicsDrawerControlButton({ className }: { className?: string }) {
  return (
    <BaseReflectionTopicsDrawerControlButton
      className={className}
      drawerId={WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
    />
  );
}

export function VisitorWaitingReflectionTopicsDrawerControlMenuItem({ className }: { className?: string }) {
  return (
    <BaseReflectionTopicsDrawerControlMenuItem
      className={className}
      drawerId={WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
    />
  );
}
